export const candidateSourceStoreKey = 'candidateSource';
